import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Actions from '../redux/actions/index';
import io from 'socket.io-client';
import QRCode from "qrcode.react";
import ScreenShare from "../component/ScreenShare";
import { v4 as uuidv4 } from 'uuid';
import Constants, { SHOPPING_DOMAIN, SOCKET_IO_PATH, SOCKET_RTC_URL, SOCKET_URL } from "../utils/Constants";
import Avatar from 'react-avatar';
import AppLoader from "../utils/AppLoader";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import NoEffect from '../assets/img/no_effect.svg'
import stringTamil from "../utils/stringTamil";
import stringEnglish from "../utils/stringEnglish";
import {
    getVideoDevicesSummary,
    getUserMediaForCameraSwitch,
    shouldOfferCameraSwitch,
    SWITCH_CAMERA_NOT_SUPPORTED_MSG,
} from '../utils/videoInputDevices';
import PatientCallSession from '../utils/patientCallSession';

let canvas = null;
let width = 320;
let height = 0;
var backgroundInterval
var segmentationStream = true
class KioskVerification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roomId: '',
            isChatOpened: false,
            chat: [],
            message: '',
            isMute: false,
            isVideoMute: false,
            unreadMessageCount: 0,
            isZoom: false,
            isScreenShared: false,
            isCaptureButton: false,
            verificationImage: "",
            screenRoomId: "",
            isScreenView: false,
            video: [],
            microphone: [],
            speaker: [],
            chatList: [],
            avatarmain: false,
            customerName: '',
            agentName: '',
            connnectionMessage: {},
            checkIsConnected: false,
            isLoading: false,
            isMobileDevice: false,
            isVrBackgroundIcon: false,
            isVirtualBackground: false,
            isVirtualBackgroundIMG: '',
            virtualBackgroundSelectId: 0,
            virtualBackgroundImages: [],
            vbOption: 1,
            language: parseInt(localStorage.getItem("language")) || 1,
            localStreamStarted: false,
            canSwitchCamera: false,
            videoInputDeviceIds: [],
            activeVideoDeviceIndex: 0,
            isSwitchingCamera: false,
            callPhase: 'ringing',
            callDurationDisplay: '00:00:00',
            showCallDuration: false,
            isReconnectingStream: false,
            showEndCallConfirm: false,
            isVideoSwapped: false,
        }
        this.canvasRef = React.createRef();
        this._callDurationInterval = null;
        this._callDurationStart = 0;
        this._reconnectRetryTimer = null;
        this._reconnectInterval = null;
        this._reconnectDeadlineTimer = null;
        this._reconnectStartedAt = null;
        this._isReconnectingStream = false;
        this._isEndingCall = false;
        this._blockedSessionStart = false;
    }

    formatCallDuration = (totalSeconds) => {
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;
        return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
    };

    startCallDurationTimer = () => {
        if (this._callDurationInterval) {
            return;
        }
        this._callDurationStart = Date.now();
        this.setState({ showCallDuration: true, callDurationDisplay: '00:00:00' });
        this._callDurationInterval = setInterval(() => {
            const elapsed = Math.floor((Date.now() - this._callDurationStart) / 1000);
            this.setState({ callDurationDisplay: this.formatCallDuration(elapsed) });
        }, 1000);
    };

    stopCallDurationTimer = () => {
        if (this._callDurationInterval) {
            clearInterval(this._callDurationInterval);
            this._callDurationInterval = null;
        }
    };

    getCallStatusIconHtml = (showLoader = false) => {
        if (showLoader) {
            return '<div class="nurse-spinner" aria-hidden="true"><span></span><span></span><span></span></div>';
        }
        return '<div class="call-status-avatar" aria-hidden="true"><i class="fa-solid fa-user-nurse"></i></div>';
    };

    toggleVideoSwap = () => {
        this.setState(
            (prev) => ({ isVideoSwapped: !prev.isVideoSwapped }),
            () => this.refreshVideoSwapTargets()
        );
    };

    /** WhatsApp-style: tap the mini video to swap local/remote main vs PiP */
    refreshVideoSwapTargets = () => {
        const container = document.getElementById('videos-container');
        if (!container) {
            return;
        }
        const localEl = container.querySelector('.media-container.front-video');
        const remoteEl = container.querySelector('.media-container.background-video');
        if (!localEl && !remoteEl) {
            return;
        }
        const swapped = !!this.state.isVideoSwapped;
        if (localEl) {
            localEl.setAttribute('title', swapped ? '' : 'Tap to swap');
            localEl.setAttribute('aria-label', swapped ? 'Your video (main)' : 'Your video — tap to swap');
        }
        if (remoteEl) {
            remoteEl.setAttribute('title', swapped ? 'Tap to swap' : '');
            remoteEl.setAttribute('aria-label', swapped ? 'Remote video — tap to swap' : 'Remote video (main)');
        }
    };

    bindVideoSwapClick = () => {
        const container = document.getElementById('videos-container');
        if (!container || container.dataset.swapBound === '1') {
            return;
        }
        container.dataset.swapBound = '1';
        container.addEventListener('click', (e) => {
            const pipSelector = this.state.isVideoSwapped
                ? '.media-container.background-video'
                : '.media-container.front-video';
            const pip = e.target.closest(pipSelector);
            if (!pip || !container.contains(pip)) {
                return;
            }
            if (e.target.closest('.customer-end-call-content') || e.target.closest('.icons')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            this.toggleVideoSwap();
        });
        this.refreshVideoSwapTargets();
    };

    applyRemoteCameraOff = (isOff, { isVirtualBackground, isScreenView } = {}) => {
        const vb = typeof isVirtualBackground === 'boolean' ? isVirtualBackground : this.state.isVirtualBackground;
        const screenView = typeof isScreenView === 'boolean' ? isScreenView : this.state.isScreenView;
        this.setState({ avatarmain: !!isOff });

        const remoteVideo = document.getElementById('video');
        const bgCanvas = document.getElementById('bgCanvas');

        if (isOff) {
            if (remoteVideo) {
                remoteVideo.style.visibility = 'hidden';
            }
            if (bgCanvas) {
                bgCanvas.style.visibility = 'hidden';
            }
            return;
        }

        if (vb && bgCanvas) {
            bgCanvas.style.visibility = '';
            if (screenView) {
                bgCanvas.setAttribute('style', 'display: block;position: absolute;height: 150px !important;width: auto !important;top: 3vh;right: 2vw;border: 2px solid white;border-radius: 10px;');
            } else {
                bgCanvas.style.display = 'block';
            }
            if (remoteVideo) {
                remoteVideo.style.display = 'none';
                remoteVideo.style.visibility = '';
            }
        } else {
            if (bgCanvas) {
                bgCanvas.style.display = 'none';
                bgCanvas.style.visibility = '';
            }
            if (remoteVideo) {
                remoteVideo.style.display = 'block';
                remoteVideo.style.visibility = '';
            }
        }
    };

    getNameInitial = (name, fallback = 'U') => {
        const trimmed = (name || '').trim();
        if (!trimmed) {
            return fallback;
        }
        return trimmed.charAt(0).toUpperCase();
    };

    attachRemoteVideoMuteListeners = (stream) => {
        if (!stream || typeof stream.getVideoTracks !== 'function') {
            return;
        }
        stream.getVideoTracks().forEach((track) => {
            if (track._remoteMuteBound) {
                return;
            }
            track._remoteMuteBound = true;
            track.addEventListener('mute', () => {
                this.applyRemoteCameraOff(true);
            });
            track.addEventListener('unmute', () => {
                this.applyRemoteCameraOff(false);
            });
        });
    };

    updateCallStatusOverlay = (title, subtitle = '', { showLoader = false } = {}) => {
        const overlay = document.querySelector('#videos-container .initial-connect');
        if (!overlay) {
            return;
        }
        overlay.classList.toggle('call-phase-connecting', !!showLoader);
        overlay.classList.toggle('call-phase-ringing', !showLoader);
        const titleEl = overlay.querySelector('.call-status-title');
        const subtitleEl = overlay.querySelector('.call-status-subtitle');
        const iconWrap = overlay.querySelector('.call-status-icon');
        const avatarEl = overlay.querySelector('.call-status-avatar');
        if (titleEl) {
            titleEl.textContent = title;
        }
        if (subtitleEl) {
            subtitleEl.textContent = subtitle || '';
            subtitleEl.style.display = subtitle ? 'block' : 'none';
        }
        if (showLoader) {
            if (avatarEl) {
                avatarEl.style.display = 'none';
            }
            if (iconWrap) {
                iconWrap.innerHTML = this.getCallStatusIconHtml(true);
            }
        } else {
            if (avatarEl) {
                avatarEl.style.display = '';
            }
            if (iconWrap) {
                iconWrap.innerHTML = '';
            }
        }
    };

    removeCallStatusOverlay = () => {
        const overlay = document.querySelector('#videos-container .initial-connect');
        if (overlay) {
            overlay.remove();
        }
        this.setState({ callPhase: 'connected' });
        this.startCallDurationTimer();
    };

    handleVideoDevicesChanged = () => {
        this.refreshVideoInputDeviceList();
    };

    refreshVideoInputDeviceList = async () => {
        try {
            const summary = await getVideoDevicesSummary();
            const canSwitchCamera = shouldOfferCameraSwitch({
                ids: summary.ids,
                videoInputCount: summary.videoInputCount,
            });
            const videoInputDeviceIds = summary.ids;
            let activeVideoDeviceIndex = this.state.activeVideoDeviceIndex;
            const currentTrack = this.mediaStream?.getVideoTracks?.()?.[0];
            const currentId = currentTrack?.getSettings?.()?.deviceId;
            if (currentId && videoInputDeviceIds.length) {
                const idx = videoInputDeviceIds.indexOf(currentId);
                if (idx >= 0) activeVideoDeviceIndex = idx;
            }
            this.setState({ videoInputDeviceIds, canSwitchCamera, activeVideoDeviceIndex });
            return { ...summary, canSwitchCamera };
        } catch {
            this.setState({ videoInputDeviceIds: [], canSwitchCamera: false });
            return { ids: [], videoInputCount: 0, canSwitchCamera: false };
        }
    };

    switchCamera = async () => {
        const { isSwitchingCamera, isVideoMute } = this.state;
        if (!this.mediaStream || !this.connection || isSwitchingCamera) {
            return;
        }
        const snap = await this.refreshVideoInputDeviceList();
        if (!snap.canSwitchCamera) {
            return;
        }
        const { ids } = snap;
        const useDeviceIdCycle = ids.filter(Boolean).length >= 2;
        let targetDeviceId = null;
        let nextIdx = 0;

        if (useDeviceIdCycle) {
            const currentTrackProbe = this.mediaStream.getVideoTracks()[0];
            const currentId = currentTrackProbe?.getSettings?.()?.deviceId;
            if (currentId && ids.includes(currentId)) {
                nextIdx = (ids.indexOf(currentId) + 1) % ids.length;
            } else {
                nextIdx = (this.state.activeVideoDeviceIndex + 1) % ids.length;
            }
            targetDeviceId = ids[nextIdx];
            let guard = 0;
            while (currentId && targetDeviceId === currentId && guard < ids.length) {
                nextIdx = (nextIdx + 1) % ids.length;
                targetDeviceId = ids[nextIdx];
                guard += 1;
            }
        }

        const currentTrack = this.mediaStream.getVideoTracks()[0];
        const pip = document.querySelector('#videos-container .media-container.front-video');
        pip?.classList?.add('camera-switch-lock');
        this.setState({ isSwitchingCamera: true });
        try {
            const newStream = await getUserMediaForCameraSwitch({
                targetDeviceId: useDeviceIdCycle ? targetDeviceId : null,
                currentVideoTrack: currentTrack,
                priorFacingMode: currentTrack?.getSettings?.()?.facingMode,
                mediaStream: this.mediaStream,
            });
            const newVideoTrack = newStream.getVideoTracks()[0];
            if (!newVideoTrack || newVideoTrack.readyState === 'ended') {
                try {
                    newVideoTrack?.stop();
                } catch {
                    /* ignore */
                }
                throw new Error('SWITCH_CAMERA_NO_TRACK');
            }

            const oldVideoTracks = [...this.mediaStream.getVideoTracks()];
            const participants =
                typeof this.connection.getAllParticipants === 'function'
                    ? this.connection.getAllParticipants()
                    : [];

            if (participants.length > 0) {
                if (typeof this.connection.replaceTrack !== 'function') {
                    try {
                        newVideoTrack.stop();
                    } catch {
                        /* ignore */
                    }
                    throw new Error('SWITCH_CAMERA_NO_REPLACE');
                }
                try {
                    this.connection.replaceTrack(newVideoTrack, null, true);
                } catch (replaceErr) {
                    try {
                        newVideoTrack.stop();
                    } catch {
                        /* ignore */
                    }
                    throw replaceErr;
                }
            }

            oldVideoTracks.forEach((t) => {
                try {
                    this.mediaStream.removeTrack(t);
                } catch {
                    /* ignore */
                }
                if (t.id !== newVideoTrack.id) {
                    try {
                        t.stop();
                    } catch {
                        /* ignore */
                    }
                }
            });
            const alreadyAttached = this.mediaStream
                .getVideoTracks()
                .some((t) => t === newVideoTrack);
            if (!alreadyAttached) {
                this.mediaStream.addTrack(newVideoTrack);
            }
            if (isVideoMute) {
                newVideoTrack.enabled = false;
            }
            const canvasVideo = document.getElementById('canvasVideo');
            if (canvasVideo) {
                this.playStreamSafely(canvasVideo);
            }
            this.setState({ activeVideoDeviceIndex: nextIdx });
            await this.refreshVideoInputDeviceList();
        } catch (err) {
            console.warn('switchCamera', err);
            if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
                toast.error('Camera permission is required to switch.');
            } else {
                if (this.mediaStream && this.mediaStream.getVideoTracks().length === 0) {
                    try {
                        const rescue = await navigator.mediaDevices.getUserMedia({
                            video: { facingMode: { ideal: 'user' } },
                            audio: false,
                        });
                        const rt = rescue.getVideoTracks()[0];
                        if (rt) {
                            this.mediaStream.addTrack(rt);
                            if (typeof this.connection.replaceTrack === 'function') {
                                try {
                                    this.connection.replaceTrack(rt, null, true);
                                } catch {
                                    /* ignore */
                                }
                            }
                            if (isVideoMute) {
                                rt.enabled = false;
                            }
                            const canvasVideo = document.getElementById('canvasVideo');
                            if (canvasVideo) {
                                this.playStreamSafely(canvasVideo);
                            }
                        }
                    } catch {
                        /* ignore */
                    }
                }
                toast.error(SWITCH_CAMERA_NOT_SUPPORTED_MSG);
            }
        } finally {
            pip?.classList?.remove('camera-switch-lock');
            this.setState({ isSwitchingCamera: false });
        }
    };

    playStreamSafely = (media) => {
        if (!media || typeof media.play !== 'function') {
            return;
        }
        const playPromise = media.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
                // Safari can block autoplay with audio; retry muted to keep video visible.
                media.muted = true;
                const retryPromise = media.play();
                if (retryPromise && typeof retryPromise.catch === 'function') {
                    retryPromise.catch(() => { });
                }
            });
        }
    }

    appHeight = () => {
        if (this._appHeightTimer) clearTimeout(this._appHeightTimer);
        if (this._appHeightRaf) cancelAnimationFrame(this._appHeightRaf);
        this._appHeightTimer = setTimeout(() => {
            this._appHeightTimer = null;
            this._appHeightRaf = requestAnimationFrame(() => {
                this._appHeightRaf = null;
                const doc = document.documentElement;
                const h = window.innerHeight;
                doc.style.setProperty('--app-height', `${h}px`);
                doc.style.setProperty('--video-height', `${h * 0.3}px`);
                doc.style.setProperty('--chat-height', `${h * 0.7}px`);
                doc.style.setProperty('--screen-share-height', `${h * 0.85}px`);
            });
        }, 200);
    }

    componentWillUnmount() {
        // Browser Back / route change does NOT fire beforeunload — end nurse call here
        this.endPatientCallOnUnexpectedLeave();
        this.stopCallDurationTimer();
        this.hideReconnectOverlay();
        window.removeEventListener('online', this._onNetworkOnline);
        if (this._appHeightTimer) {
            clearTimeout(this._appHeightTimer);
            this._appHeightTimer = null;
        }
        if (this._appHeightRaf) {
            cancelAnimationFrame(this._appHeightRaf);
            this._appHeightRaf = null;
        }
        window.removeEventListener('resize', this.appHeight)
        try {
            window.removeEventListener('beforeunload', this.handleTabClose);
            window.removeEventListener('pagehide', this.handlePageHide);
        } catch {
            /* ignore */
        }
        if (navigator.mediaDevices && navigator.mediaDevices.removeEventListener) {
            navigator.mediaDevices.removeEventListener('devicechange', this.handleVideoDevicesChanged);
        }
        this.setState({ localStreamStarted: false });
    }

    /**
     * Patient pressed Back / left call page without End Call.
     * Still ends appointment so the nurse stops ringing / disconnects.
     */
    endPatientCallOnUnexpectedLeave = () => {
        if (!this.props.isCustomer) {
            return;
        }
        if (this._isEndingCall || this._blockedSessionStart) {
            return;
        }
        const roomId = this.props.match?.params?.roomId;
        if (!roomId) {
            return;
        }
        this._isEndingCall = true;
        PatientCallSession.markClosed(roomId);
        const payload = {
            roomId,
            callEndTime: new Date().getTime(),
        };
        PatientCallSession.beaconEndCall(payload);
        try {
            this.props.customerDeclineAction(payload, () => { /* idempotent */ });
        } catch (e) {
            /* ignore */
        }
        try {
            this.releaseCallSession();
        } catch (e) {
            /* ignore */
        }
    };

    getConnectedDevices = async (type) => {
        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.filter(device => device.kind === type)
    }

    getVideoElement = async () => {
        const video = await this.getConnectedDevices('videoinput');
        const audio = await this.getConnectedDevices('audioinput');
        const speaker = await this.getConnectedDevices('audiooutput');
        this.setState({ video, audio, speaker });
    }

    componentDidMount() {
        const isMobile = /Mobile/.test(window.navigator.userAgent) || window.matchMedia("(max-width: 767px)").matches;
        this.setState({ isMobileDevice: isMobile })
        const roomId = this.props.match.params.roomId;
        const { isCustomer } = this.props;

        if (isCustomer && PatientCallSession.shouldTreatAsSessionEnded(roomId)) {
            this.handlePatientSessionEndedOnLoad(roomId);
            return;
        }

        window.addEventListener('beforeunload', this.handleTabClose);
        window.addEventListener('pagehide', this.handlePageHide);
        if (navigator.mediaDevices && navigator.mediaDevices.addEventListener) {
            navigator.mediaDevices.addEventListener('devicechange', this.handleVideoDevicesChanged);
        }
        this.setState({ roomId })

        if (isCustomer) {
            PatientCallSession.markActive(roomId);
        }

        // Hospital emergency: start WebRTC immediately — do not wait for chatList API
        this.getVideoElement();
        window.addEventListener('resize', this.appHeight)
        this.appHeight()
        window.addEventListener('online', this._onNetworkOnline);
        this.loadVideoConferencing();
        this.setupAppCallSocket();

        const callBack = (response) => {
            if (response.response_code === 0) {
                this.setState({ chatList: response?.response?.ChatMessages.sort((f, s) => f?.id - s?.id), customerName: response?.response?.customerName, agentName: response?.response?.agentName })
                this.getVirtualBackgroundList()
            }
            else {
                if (!this.props.isCustomer) {
                    this.props.history.push('/store')
                } else if (this.state.localStreamStarted || this.connection) {
                    console.warn('chatList failed; continuing live call');
                } else {
                    this.goToPatientFeedback();
                }
            }
        }
        const params = {
            roomId: this.props.match.params.roomId
        }
        this.props.chatListAction(params, callBack)

    }

    handlePatientSessionEndedOnLoad = (roomId) => {
        this._isEndingCall = true;
        this._blockedSessionStart = true;
        PatientCallSession.clearLeftMidCall(roomId);
        PatientCallSession.clearActive(roomId);
        PatientCallSession.markClosed(roomId);
        PatientCallSession.flagSessionEndedMessage();
        const params = {
            roomId,
            callEndTime: new Date().getTime(),
        };
        try {
            this.props.customerDeclineAction(params, () => { /* idempotent */ });
        } catch (e) {
            /* ignore */
        }
        // Toast shown once on feedback page via consumeSessionEndedMessage
        this.goToPatientFeedback({ showSessionEndedMsg: false });
    };

    goToPatientFeedback = ({ showSessionEndedMsg = false } = {}) => {
        // Mark intentional leave so unmount does not fire a second decline
        this._isEndingCall = true;
        try {
            this.releaseCallSession();
        } catch (e) {
            /* ignore */
        }
        const roomId = this.props.match.params.roomId;
        if (roomId) {
            PatientCallSession.markClosed(roomId);
            PatientCallSession.clearActive(roomId);
            PatientCallSession.clearLeftMidCall(roomId);
            PatientCallSession.saveFeedbackRoomId(roomId);
        }
        if (showSessionEndedMsg) {
            PatientCallSession.flagSessionEndedMessage();
        } else {
            PatientCallSession.clearSessionEndedMessage();
        }
        this.props.history.replace('/kiosk_srm/customer/feedback');
        try {
            this.mediaStream?.stop?.();
        } catch (e) {
            /* ignore */
        }
    };

    setupAppCallSocket = () => {
        if (window.location.hostname === 'localhost') {
            this.socketURL = SOCKET_URL;
        } else {
            this.socketURL = SOCKET_URL;
        }
        const socket = io(this.socketURL, { path: SOCKET_IO_PATH, transports: ['websocket'] });
        this.socket = socket;
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        socket.on(`chat/${roomId}/${!isCustomer ? 'customer' : 'store'}`, (response) => {
            let arrayList = []
            arrayList = this.props.getChatListAction
            arrayList.push(response?.message.ChatMessages)
            this.props.appendChat(arrayList)
            let { unreadMessageCount = 0, isChatOpened } = this.state
            if (!isChatOpened) {
                unreadMessageCount = unreadMessageCount + 1
            }
            this.setState({ unreadMessageCount })
        })

        socket.on(`endcall/${roomId}/${!isCustomer ? 'customer' : 'store'}`, (response) => {
            this.endCall(true);
            if (!isCustomer) {
                window.close()
            } else {
                this.goToPatientFeedback();
            }
        })
        socket.on(`call_connect/${roomId}`, (response) => {
            const isRealAttend = response?.callPhase === 'connecting'
                || response?.status === 'connecting'
                || response?.callPhase === 'connected'
                || response?.status === 'connected';
            if (!isRealAttend) {
                if (response?.agentName || response?.customerName) {
                    this.setState({
                        customerName: response?.customerName || this.state.customerName,
                        agentName: response?.agentName || this.state.agentName,
                    });
                }
                return;
            }
            const agentName = response?.agentName || '';
            this.setState({
                customerName: response?.customerName,
                agentName,
                callPhase: 'connecting',
            });
            // Duration starts only when remote media connects
            if (this.props.isCustomer) {
                this.updateCallStatusOverlay(
                    'Connecting...',
                    agentName ? `Connecting with ${agentName}` : 'Nurse answered. Establishing video...',
                    { showLoader: true }
                );
                const overlay = document.querySelector('#videos-container .initial-connect');
                if (overlay) {
                    overlay.classList.remove('call-phase-ringing');
                    overlay.classList.add('call-phase-connecting');
                }
            }
        })

        socket.on(`screen/${roomId}/${!isCustomer ? 'customer' : 'store'}`, (response) => {
            const { roomData } = response;
            const { isVirtualBackground } = this.state
            const { isCustomer } = this.props
            let backgroundCanvas = document.getElementById("bgCanvas")
            if (roomData.stop) {
                this.setState({
                    isScreenView: false,
                    screenRoomId: ''
                })
                if (isCustomer && isVirtualBackground) {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto")
                    this.canvasRef.current = backgroundCanvas
                }
            } else {
                this.setState({
                    isScreenView: true,
                    screenRoomId: roomData.screenRoomId
                })
                if (isCustomer && isVirtualBackground) {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;height: 150px !important;width: auto !important;top: 3vh;right: 2vw;border: 2px solid white;border-radius: 10px;")
                    this.canvasRef.current = backgroundCanvas
                }
            }
        })
        socket.on(`end_streaming/${roomId}`, (response) => {
            console.log("end Stream Socket------>", response)
        })
        socket.on(`age_verification/${roomId}`, (response) => {
            if (response?.message?.isAbove18) {
                toast.success(`Profile verified age is ${response?.message?.age}`)
                if (!isCustomer) {
                    this.onCaptureButtonClose()
                }
            } else {
                if (response?.message?.age === null) {
                    if (isCustomer) {
                        toast.error(`Could not able to recognized the image.`)
                    } else {
                        toast.error(`Could not able to recognized the image please retake.`)
                    }
                } else {
                    toast.error("Profile not verified.")
                }
            }

        })
        socket.on(`virtual_back_ground/${roomId}/${isCustomer ? 'customer' : 'store'}`, (response) => {
            if (response) {
                let findDinamicImgDiv = document.getElementsByClassName("dinamicImgDiv")
                if (findDinamicImgDiv.length > 0) {
                    document.querySelector('#videos-container').removeChild(findDinamicImgDiv[0])
                }
                let createDinamicImg = document.createElement('div');
                createDinamicImg.className = "dinamicImgDiv"
                createDinamicImg.innerHTML = `<img id='vbackground_${response?.id}' src=${this.setImg(response?.id, response?.imageURL)} alt="dinamic" />`
                document.querySelector('#videos-container').appendChild(createDinamicImg)
                let img = document.getElementById(`vbackground_${response?.id}`)
                img.setAttribute("style", 'display: none')
                this.setVideo(img, response?.id);
            }
        })
    }
    setImg = (key, imageURL) => {
        switch (key) {
            case 0:
                return NoEffect
            default:
                return imageURL
        }
    }
    onResults = async (results) => {
        const { isVirtualBackgroundIMG } = this.state
        // const img = document.getElementById(`vbackground_${isVirtualBackgroundIMG}`)
        const img = isVirtualBackgroundIMG
        const videoWidth = results?.image?.width;
        const videoHeight = results?.image?.height;
        this.canvasRef.current.width = videoWidth;
        this.canvasRef.current.height = videoHeight;

        const canvasElement = this.canvasRef.current;
        const canvasCtx = canvasElement.getContext("2d");

        canvasCtx.save();
        canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.drawImage(results.image, 0, 0, canvasElement.width, canvasElement.height);

        // Only overwrite existing pixels.
        canvasCtx.globalCompositeOperation = 'destination-atop';
        canvasCtx.drawImage(results.segmentationMask, 0, 0, canvasElement.width, canvasElement.height);

        // Only overwrite missing pixels.

        canvasCtx.globalCompositeOperation = 'destination-over';
        canvasCtx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.restore();

    }
    virtualBackgroundSet = (stream, useSegment) => {
        const selfieSegmentation = new SelfieSegmentation({
            locateFile: (file) => {
                return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
            },
        });
        selfieSegmentation.setOptions({
            modelSelection: 1,
        });
        selfieSegmentation.onResults(this.onResults);
        if (segmentationStream) {
            const processFrame = async () => {
                await selfieSegmentation.send({ image: stream });
                requestAnimationFrame(processFrame);
            };
            requestAnimationFrame(processFrame);
            segmentationStream = false;
        }
        // if (useSegment) {
        //     myRef = requestAnimationFrame(processFrame);
        // } else {
        //     cancelAnimationFrame(myRef);
        // }
        //     const camera = new cam.Camera(stream, {
        //         onFrame: async () => {
        //             await selfieSegmentation.send({ image: stream });
        //         },
        //         width: 1280,
        //         height: 720
        //     });
        //     selfieSegmentation.send({ image: stream });
        //     if (useSegment) {
        //         camera.start();
        //     } else {
        //         camera.stop();
        //     }
    }
    handleTabClose = (event) => {
        if (this._isEndingCall || this._blockedSessionStart) {
            return;
        }
        const { isCustomer } = this.props;
        if (isCustomer) {
            const roomId = this.props.match.params.roomId;
            PatientCallSession.markLeftMidCall(roomId);
            PatientCallSession.beaconEndCall({ roomId });
            return;
        }
        event.preventDefault();
        event.returnValue = '';
        this.endCall();
    }

    handlePageHide = (event) => {
        if (event && event.persisted) {
            return;
        }
        if (this._isEndingCall || this._blockedSessionStart) {
            return;
        }
        if (!this.props.isCustomer) {
            return;
        }
        const roomId = this.props.match.params.roomId;
        PatientCallSession.markLeftMidCall(roomId);
        PatientCallSession.beaconEndCall({ roomId });
    }

    _onCallSocketDisconnect = () => {
        if (this._isEndingCall) {
            return;
        }
        this.beginStreamReconnect('Network interrupted. Reconnecting…');
    }

    _onNetworkOnline = () => {
        if (this._isEndingCall) {
            return;
        }
        this.beginStreamReconnect('Network back. Restoring video…');
        this.attemptStreamReconnect();
    }

    _onRtcSocketReconnect = () => {
        if (this._isEndingCall || !this._isReconnectingStream) {
            return;
        }
        this.attemptStreamReconnect();
    }

    clearReconnectTimers = () => {
        if (this._reconnectRetryTimer) {
            clearTimeout(this._reconnectRetryTimer);
            this._reconnectRetryTimer = null;
        }
        if (this._reconnectInterval) {
            clearInterval(this._reconnectInterval);
            this._reconnectInterval = null;
        }
        if (this._reconnectDeadlineTimer) {
            clearTimeout(this._reconnectDeadlineTimer);
            this._reconnectDeadlineTimer = null;
        }
    }

    updateReconnectOverlayCountdown = () => {
        if (!this._reconnectStartedAt) {
            return;
        }
        const remainingMs = Math.max(0, (2 * 60 * 1000) - (Date.now() - this._reconnectStartedAt));
        const remainingSec = Math.ceil(remainingMs / 1000);
        const overlay = document.querySelector('#videos-container .stream-reconnect-overlay');
        const sub = overlay && overlay.querySelector('.stream-reconnect-sub');
        if (sub) {
            sub.textContent = remainingSec > 0
                ? `Retrying every 8s. Call ends in ${remainingSec}s if not restored`
                : 'Unable to reconnect. Ending call…';
        }
    }

    beginStreamReconnect = (message = 'Network interrupted. Reconnecting…') => {
        if (this._isEndingCall) {
            return;
        }
        this._isReconnectingStream = true;
        this.setState({ isReconnectingStream: true });
        this.showReconnectOverlay(message);

        if (!this._reconnectStartedAt) {
            this._reconnectStartedAt = Date.now();
        }

        this.clearReconnectTimers();
        this.updateReconnectOverlayCountdown();

        const remainingMs = Math.max(0, (2 * 60 * 1000) - (Date.now() - this._reconnectStartedAt));
        this._reconnectDeadlineTimer = setTimeout(() => {
            this.forceEndCallAfterReconnectTimeout();
        }, remainingMs || 1);

        this.attemptStreamReconnect();
        this._reconnectInterval = setInterval(() => {
            if (this._isEndingCall || !this._isReconnectingStream) {
                this.clearReconnectTimers();
                return;
            }
            this.updateReconnectOverlayCountdown();
            this.attemptStreamReconnect();
        }, 8000);
    }

    forceEndCallAfterReconnectTimeout = () => {
        if (this._isEndingCall) {
            return;
        }
        this.showReconnectOverlay('Unable to reconnect. Ending call…');
        const sub = document.querySelector('#videos-container .stream-reconnect-overlay .stream-reconnect-sub');
        if (sub) {
            sub.textContent = 'Connection could not be restored within 2 minutes';
        }
        this.clearReconnectTimers();
        this._reconnectRetryTimer = setTimeout(() => {
            this.hideReconnectOverlay();
            this.endCall();
        }, 900);
    }

    showReconnectOverlay = (message) => {
        let overlay = document.querySelector('#videos-container .stream-reconnect-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.className = 'stream-reconnect-overlay';
            overlay.innerHTML = `
                <div class="stream-reconnect-box">
                    <p class="stream-reconnect-title">${message}</p>
                    <p class="stream-reconnect-sub">Retrying every 8s. Call ends in 2 minutes if not restored</p>
                </div>
            `;
            const container = document.querySelector('#videos-container');
            if (container) {
                container.appendChild(overlay);
            }
        } else {
            const title = overlay.querySelector('.stream-reconnect-title');
            if (title) {
                title.textContent = message;
            }
        }
        this.updateReconnectOverlayCountdown();
    }

    hideReconnectOverlay = () => {
        const overlay = document.querySelector('#videos-container .stream-reconnect-overlay');
        if (overlay) {
            overlay.remove();
        }
        this.clearReconnectTimers();
        this._reconnectStartedAt = null;
        this._isReconnectingStream = false;
        this.setState({ isReconnectingStream: false });
    }

    ensureLocalMediaAlive = async () => {
        try {
            const tracks = this.mediaStream && this.mediaStream.getTracks ? this.mediaStream.getTracks() : [];
            const hasLiveAudio = tracks.some((t) => t.kind === 'audio' && t.readyState === 'live');
            const hasLiveVideo = tracks.some((t) => t.kind === 'video' && t.readyState === 'live');
            if (hasLiveAudio && hasLiveVideo) {
                return;
            }
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: { facingMode: 'user' }
            });
            this.mediaStream = stream;
            if (this.connection) {
                this.connection.attachStreams = [stream];
                try {
                    if (typeof this.connection.replaceTrack === 'function' && stream.getVideoTracks()[0]) {
                        this.connection.replaceTrack(stream.getVideoTracks()[0]);
                    }
                } catch (e) {
                    /* ignore */
                }
            }
            const localVideo = document.getElementById('canvasVideo');
            if (localVideo) {
                localVideo.srcObject = stream;
            }
        } catch (e) {
            /* camera may be unavailable while offline */
        }
    }

    attemptStreamReconnect = async () => {
        if (this._isEndingCall || !this._isReconnectingStream) {
            return;
        }
        await this.ensureLocalMediaAlive();
        this.rejoinCallRoom();
    }

    rejoinCallRoom = () => {
        const { roomId } = this.props.match.params;
        if (!this.connection || this._isEndingCall || !roomId) {
            return;
        }
        try {
            if (this.connection.socket && !this.connection.socket.connected) {
                try {
                    this.connection.socket.connect();
                } catch (e) {
                    /* ignore */
                }
            }
            this.connection.sdpConstraints.mandatory = {
                OfferToReceiveAudio: true,
                OfferToReceiveVideo: true
            };
            if (this.mediaStream) {
                this.connection.attachStreams = [this.mediaStream];
            }
            this.connection.openOrJoin(roomId, () => {
                this.attachRtcReconnectHandlers();
                try {
                    if (typeof this.connection.renegotiate === 'function') {
                        const peers = this.connection.getAllParticipants
                            ? this.connection.getAllParticipants()
                            : [];
                        if (peers && peers.length) {
                            peers.forEach((pid) => {
                                try {
                                    this.connection.renegotiate(pid);
                                } catch (e) {
                                    /* ignore */
                                }
                            });
                        } else {
                            this.connection.renegotiate();
                        }
                    }
                } catch (e) {
                    /* ignore */
                }
            });
        } catch (err) {
            /* next 5s interval will retry */
        }
    }

    attachRtcReconnectHandlers = () => {
        if (!this.connection?.socket) {
            return;
        }
        try {
            this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
            this.connection.socket.on('disconnect', this._onCallSocketDisconnect);
            this.connection.socket.off('connect', this._onRtcSocketReconnect);
            this.connection.socket.on('connect', this._onRtcSocketReconnect);
        } catch {
            /* ignore */
        }
        this.attachIceReconnectHandler();
    }

    attachIceReconnectHandler = () => {
        if (!this.connection || !this.props.isCustomer) {
            return;
        }
        this.connection.onPeerStateChanged = (states) => {
            if (this._isEndingCall || this._blockedSessionStart) {
                return;
            }
            const ice = states && states.iceConnectionState;
            if (!ice) {
                return;
            }
            if (ice === 'connected' || ice === 'completed') {
                if (this._isReconnectingStream) {
                    this.hideReconnectOverlay();
                    this.clearReconnectTimers();
                    this._isReconnectingStream = false;
                    this._reconnectStartedAt = null;
                    this.setState({ isReconnectingStream: false });
                }
                return;
            }
            if (ice === 'disconnected' || ice === 'failed') {
                this.beginStreamReconnect('Video interrupted. Reconnecting…');
            }
        };
    }

    releaseCallSession = () => {
        this._isEndingCall = true;
        this.clearReconnectTimers();
        this._reconnectStartedAt = null;
        this._isReconnectingStream = false;
        try {
            window.removeEventListener('beforeunload', this.handleTabClose);
            window.removeEventListener('pagehide', this.handlePageHide);
        } catch {
            /* ignore */
        }
        if (this.connection?.socket) {
            try {
                this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
                this.connection.socket.off('connect', this._onRtcSocketReconnect);
            } catch {
                /* ignore */
            }
        }
        try {
            this.mediaStream?.getTracks?.().forEach((track) => track.stop());
        } catch {
            /* ignore */
        }
        try {
            this.mediaStream?.stop?.();
        } catch {
            /* ignore */
        }
        try {
            this.connection?.close?.();
        } catch {
            /* ignore */
        }
    }
    getChatList = () => {
        const callBack = (response) => {
            if (response.response_code === 0) {
                this.setState({ chatList: response?.response?.ChatMessages.sort((f, s) => f?.id - s?.id) })
                return true
            }
            console.warn('chatList refresh failed; keeping call');
            return false
        }
        const params = {
            roomId: this.props.match.params.roomId
        }
        this.props.chatListAction(params, callBack)
    }
    getVirtualBackgroundList = () => {
        const callBack = (response) => {
            this.setState({ isLoading: false })
            if (response.response_code === 0) {
                this.setState({ virtualBackgroundImages: response?.response })
                return true
            }
            console.warn('virtualBackgroundList failed; keeping call');
            return false
        }
        const params = {
            roomId: this.props.match.params.roomId
        }
        this.setState({ isLoading: true })
        this.props.virtualBackgroundListAction(params, callBack)
    }
    startVideConferencing = () => {
        const { roomId } = this.props.match.params;
        if (!this.connection) {
            return false
        }
        this.connection.socket.emit(`call_request/${this.props.attenedName?.tokenDetails?.user?.id}`, { roomId })
        this.connection.openOrJoin(roomId, (isRoomOpened, roomid, error) => {
            if (error) {
                if (error === this.connection.errors.ROOM_NOT_AVAILABLE) {
                    alert('Someone already created this room. Please either join or create a separate room.');
                    return;
                }
                alert(error);
            }

            this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
            this.connection.socket.on('disconnect', this._onCallSocketDisconnect);
            this.attachRtcReconnectHandlers();
        });
    }

    joinVideConferencing = () => {
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        if (!this.connection) {
            return false
        }
        if (isCustomer) {
            this.connection.openOrJoin(roomId);
        } else {
            this.connection.sdpConstraints.mandatory = {
                OfferToReceiveAudio: true,
                OfferToReceiveVideo: true
            };
            this.connection.openOrJoin(roomId);
        }
        this.attachRtcReconnectHandlers();
    }

    loadVideoConferencing = () => {
        const { isCustomer } = this.props;
        (function () {
            var params = {},
                r = /([^&=]+)=?([^&]*)/g;

            function d(s) {
                return decodeURIComponent(s.replace(/\+/g, ' '));
            }
            var match, search = window.location.search;
            while (match === r.exec(search.substring(1)))
                params[d(match[1])] = d(match[2]);
            window.params = params;
        })();
        // ......................................................
        // ..................RTCMultiConnection Code.............
        // ......................................................

        this.connection = new global.RTCMultiConnection();
        this.connection.autoCloseEntireSession = !isCustomer;
        this.connection.publicRoomIdentifier = global.params.publicRoomIdentifier;

        // by default, socket.io server is assumed to be deployed on your own URL
        if (window.location.hostname === 'localhost') {
            this.connection.socketURL = SOCKET_RTC_URL;
        } else {
            this.connection.socketURL = SOCKET_RTC_URL;
        }


        // comment-out below line if you do not have your own socket.io server
        // connection.socketURL = 'https://rtcmulticonnection.herokuapp.com:443/';

        this.connection.socketMessageEvent = 'video-conference-demo';
        this.connection.session = {
            audio: true,
            video: true,
            // oneway: true
        };

        if (isCustomer) {
            this.connection.mediaConstraints = {
                audio: true,
                video: {
                    width: { ideal: 640, max: 854 },
                    height: { ideal: 480, max: 480 },
                    frameRate: { ideal: 15, max: 20 },
                },
            };
            this.connection.bandwidth = {
                audio: 40,
                video: 400,
            };
        }

        this.connection.sdpConstraints.mandatory = {
            OfferToReceiveAudio: true,
            OfferToReceiveVideo: true
        };

        this.connection.videosContainer = document.getElementById('videos-container');
        this.connection.onstream = (event) => {
            const isLocal = event.type === 'local';
            this.setState({
                checkIsConnected: isLocal,
                ...(isLocal ? { localStreamStarted: true } : {}),
            });
            if (isLocal) {
                const vc = document.getElementById('videos-container');
                if (vc) {
                    vc.querySelectorAll('.media-container.front-video').forEach((node) => {
                        if (node.parentNode) {
                            node.parentNode.removeChild(node);
                        }
                    });
                }
            }
            var existing = document.getElementById(event.streamid);
            if (existing && existing.parentNode) {
                existing.parentNode.removeChild(existing);
            }

            event.mediaElement.removeAttribute('src');
            event.mediaElement.removeAttribute('srcObject');
            event.mediaElement.muted = true;
            event.mediaElement.volume = 0;

            var video = document.createElement('video');
            if (isLocal) {
                this.mediaStream = event.stream
                setTimeout(() => this.refreshVideoInputDeviceList(), 400);
                setTimeout(() => this.refreshVideoInputDeviceList(), 1500);
            }
            try {
                video.setAttributeNode(document.createAttribute('autoplay'));
                video.setAttributeNode(document.createAttribute('playsinline'));
            } catch (e) {
                video.setAttribute('autoplay', true);
                video.setAttribute('playsinline', true);
            }
            video.autoplay = true;
            video.playsInline = true;

            if (event.type === 'local') {
                video.volume = 0;
                try {
                    video.setAttributeNode(document.createAttribute('muted'));
                } catch (e) {
                    video.setAttribute('muted', true);
                }
                video.muted = true;
                video.setAttribute('id', "canvasVideo"); //Back Streaming view
            } else {
                video.muted = false;
                video.setAttribute('id', "video"); //front Streaming View
            }
            video.srcObject = event.stream;
            let initialConnect;
            if (isLocal) {
                const existingOverlay = document.querySelector('#videos-container .initial-connect');
                if (!existingOverlay && this.state.callPhase !== 'connected') {
                    const phase = this.state.callPhase;
                    const showConnecting = !isCustomer || phase === 'connecting';
                    const statusTitle = showConnecting ? 'Connecting...' : 'Ringing...';
                    const statusSubtitle = showConnecting
                        ? (this.state.agentName
                            ? `Connecting with ${this.state.agentName}`
                            : 'Establishing video connection')
                        : 'Waiting for Nurse to answer';
                    if (!isCustomer && phase === 'ringing') {
                        this.setState({ callPhase: 'connecting' });
                    }
                    initialConnect = document.createElement('div');
                    initialConnect.className = `initial-connect call-phase-${showConnecting ? 'connecting' : 'ringing'}`;
                    initialConnect.insertAdjacentHTML('beforeend', `
                    <div class="call-status-box">
                        <div class="call-status-avatar" aria-hidden="true"${showConnecting ? ' style="display:none"' : ''}><i class="fa-solid fa-user-nurse"></i></div>
                        <h1 class="call-status-title">${statusTitle}</h1>
                        <p class="call-status-subtitle">${statusSubtitle}</p>
                        <div class="call-status-icon">${showConnecting ? this.getCallStatusIconHtml(true) : ''}</div>
                    </div>
                    `);
                    document.querySelector('#videos-container').appendChild(initialConnect)
                }
            } else {
                this.removeCallStatusOverlay();
                this.hideReconnectOverlay();
                this.attachRemoteVideoMuteListeners(event.stream);
            }

            var width = parseInt(this.connection.videosContainer.clientWidth / 3) - 20;
            var mediaElement = global.getHTMLMediaElement(video, {
                title: '',
                buttons: [],
                width: width,
                showOnMouseEnter: false
            }, isLocal, isCustomer);

            this.connection.videosContainer.appendChild(mediaElement);
            const streamMedia = mediaElement.media || video;
            if (streamMedia) {
                streamMedia.onloadedmetadata = () => this.playStreamSafely(streamMedia);
                setTimeout(() => this.playStreamSafely(streamMedia), 200);
            }

            mediaElement.id = event.streamid;

            if (event.type === 'local') {
                this.connection.socket.off('disconnect', this._onCallSocketDisconnect);
                this.connection.socket.on('disconnect', this._onCallSocketDisconnect);
                this.attachRtcReconnectHandlers();
            }
            setTimeout(() => this.bindVideoSwapClick(), 100);
            setTimeout(() => this.refreshVideoSwapTargets(), 150);
        };

        this.connection.onCustomMsg = (msg) => {
            this.setState({ connnectionMessage: msg })
            const { isVirtualBackground, isScreenView } = this.state
            const msgType = msg?.message?.type;
            const msgAction = msg?.message?.action;
            if ((msgType === 'video' || msgType === 'both') && (msgAction === 'mute' || msgAction === 'unmute')) {
                const isOff = msgAction === 'mute';
                this.applyRemoteCameraOff(isOff, { isVirtualBackground, isScreenView });
                return;
            }
        }

        this.connection.onstreamended = (event) => {
            var mediaElement = document.getElementById(event.streamid);
            if (mediaElement) {
                mediaElement.parentNode.removeChild(mediaElement);
            }
        };

        this.connection.onMediaError = (e) => {
            if (e.message === 'Concurrent mic process limit.') {
                if (global.DetectRTC.audioInputDevices.length <= 1) {
                    alert('Please select external microphone. Check github issue number 483.');
                    return;
                }

                var secondaryMic = global.DetectRTC.audioInputDevices[1].deviceId;
                this.connection.mediaConstraints.audio = {
                    deviceId: secondaryMic
                };

                this.connection.join(this.connection.sessionid);
            }
        };

        if (!!global.params.password) {
            this.connection.password = global.params.password;
        }

        // detect 2G
        if (navigator.connection &&
            navigator.connection.type === 'cellular' &&
            navigator.connection.downlinkMax <= 0.115) {
            alert('2G is not supported. Please use a better internet service.');
        }
        canvas = document.getElementById("canvas");
        this.joinVideConferencing()
    }

    //Function to trigger call end api by checking the isCustomer
    confirmEndCall = () => {
        this.setState({ showEndCallConfirm: false }, () => this.endCall());
    };

    endCall = (isSocket) => {
        this.setState({ showEndCallConfirm: false });
        const { isCustomer } = this.props;
        if (isSocket) {
            // Always drop beforeunload leave-prompt before closing the agent tab
            this.releaseCallSession();
            if (isCustomer) {
                const roomId = this.props.match.params.roomId;
                PatientCallSession.markClosed(roomId);
            }
            return false;
        }
        this.releaseCallSession();
        this.setState({ isLoading: true })
        if (isCustomer) {
            const params = {
                roomId: this.props.match.params.roomId,
                callEndTime: new Date().getTime(),
            }
            this.props.customerDeclineAction(params, (res) => {
                this.setState({ isLoading: false })
                this.goToPatientFeedback();
            })
        }
        else {
            let params = {
                roomId: this.props.match.params.roomId,
                callStatus: 3,
                isActive: false,
                callEndTime: new Date().getTime()
            }
            const declinecallback = (response) => {
                this.setState({ isLoading: false })
                if (!isCustomer) {
                    window.close()
                } else {
                    this.goToPatientFeedback();
                }
            }
            this.props.updateAppointment(params, declinecallback)
        }
        // this.props.customerDeclineAction(params, (res) => {
        //     if (res.response.status !== 500) {
        //         this.connection.close();
        //         if (isCustomer) {
        //             this.props.history.push('/customer');
        //             setTimeout(() => {
        //                 window.location.reload();
        //             }, 200)
        //         } else {
        //             window.close();
        //         }
        //         if (isSocket) {
        //             return false
        //         }
        //         const { roomId } = this.props.match.params;
        //         let data = {
        //             customer: !!isCustomer
        //         }
        //         const requestOptions = {
        //             method: 'POST',
        //             headers: { 'Content-Type': 'application/json' },
        //             body: JSON.stringify({ url: `endcall/${roomId}/${isCustomer ? 'customer' : 'store'}`, data })
        //         };

        //         fetch(`${this.socketURL}/api/socket`, requestOptions)
        //             .then((res) => res.json())
        //             .then(data => {
        //             })
        //     }
        //     else {
        //         return false;
        //     }
        // })

    }

    handleChange = ({ target: { name, value } }) => {
        this.setState({ [name]: value })
    }

    handleKeyUp = (e) => {
        if (e.keyCode === 13) {
            this.sendMessage()
        }
    }

    sendMessage = () => {
        const role = this.props.getTokenDetails?.LOGIN_CREDS?.tokenDetails?.user?.roleId
        const user = this.props.getTokenDetails?.LOGIN_CREDS?.tokenDetails?.user?.id
        let { message, chat } = this.state;
        if (message) {
            const { roomId } = this.props.match.params;
            let data;
            if (!this.props.isCustomer) {
                data = {
                    message,
                    roleId: role,
                    roomId,
                    userId: user
                }
            } else {
                data = {
                    message,
                    roleId: this.props.getCustomerToken?.roleId,
                    roomId,
                    userId: this.props.getCustomerToken?.id
                }
            }

            chat.push(data)
            const callBack = (response) => {
                if (response.response_code === 0) {
                    let arrayList = []
                    arrayList = this.props.getChatListAction
                    arrayList.push(response?.response?.ChatMessages)
                    this.props.socketAppendChatAction(arrayList)
                }
            }
            this.props.addChatListAction(data, callBack)
        }
        this.setState({ message: '', chat })
    }
    openApp() {
        window.open(`https://${SHOPPING_DOMAIN}`, "_blank")
    }
    openLink(link) {
        window.open(link, "_blank")
    }

    onMute = (e, check) => {
        if (check) {
            e.preventDefault()
        } else {
            this.setState({ isMute: true })
            this.mediaStream && this.mediaStream.mute('audio')
        }
    }
    onUnMute = () => {
        this.setState({ isMute: false })
        this.mediaStream && this.mediaStream.unmute('audio')
    }

    setVideoTrackEnabled = (enabled) => {
        if (!this.mediaStream || typeof this.mediaStream.getVideoTracks !== 'function') {
            return;
        }
        this.mediaStream.getVideoTracks().forEach((track) => {
            track.enabled = enabled;
        });
    }

    onMuteVideo = (e, check) => {
        if (check) {
            e.preventDefault()
        } else {
            const { isCustomer } = this.props
            this.setState({ isVideoMute: true, isVrBackgroundIcon: false })
            this.setVideoTrackEnabled(false)
            this.mediaStream && this.mediaStream.mute('video')
            this.handleAvatatOnMute();
            if (!isCustomer && this.state.virtualBackgroundSelectId) {
                clearInterval(backgroundInterval)
            }
        }
    }
    onUnMuteVideo = () => {
        const { isCustomer } = this.props
        this.setState({ isVideoMute: false })
        this.setVideoTrackEnabled(true)
        this.mediaStream && this.mediaStream.unmute('video')
        this.handleAvatatOnUnMute();
        if (!isCustomer && this.state.virtualBackgroundSelectId && this.state.vbOption === 2) {
            this.setIntervalForAutoChangeBackground(0, this.state.virtualBackgroundImages)
        }
    }

    onStartScreenShare = () => {
        const screenRoomId = uuidv4();
        this.setState({ screenRoomId, isScreenShared: true });
    }
    takePicture = () => {
        let video = document.getElementById("video")
            || document.querySelector('#videos-container .media-container.background-video video');
        const output = document.getElementById('capture-img')
        canvas = document.getElementById("canvas") || canvas;
        if (!video || !output || !canvas || !video.videoWidth) {
            return;
        }
        const context = canvas.getContext("2d");
        height = video.videoHeight / (video.videoWidth / width)
        if (isNaN(height)) {
            height = width / (4 / 3);
        }
        canvas.setAttribute("width", width);
        canvas.setAttribute("height", height);
        if (width && height) {
            context.drawImage(video, 0, 0, width, height);
            const data = canvas.toDataURL("image/png")
            const existing = document.getElementById("photo");
            if (existing && existing.parentNode) {
                existing.parentNode.removeChild(existing);
            }
            let img = document.createElement("img")
            img.id = 'photo'
            img.alt = "The screen capture will appear in this box."
            img.setAttribute("src", data);
            this.setState({ verificationImage: data })
            output.appendChild(img)
        }
    }
    onCaptureButtonOpen = () => {
        this.setState({ isCaptureButton: true }, () => {
            this.takePicture()
        });
    }
    onScreenShared = (screenRoomId) => {
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        let params = {
            roomId,
            stop: false,
            isCustomer: !!isCustomer,
            screenRoomId: this.state.screenRoomId
        }
        this.props.screenShareAction(params, (res) => {
        })
        // const requestOptions = {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({ url: `screen/${roomId}/${isCustomer ? 'customer' : 'store'}`, data })
        // };
        // fetch(`${this.socketURL}/api/socket`, requestOptions)
        //     .then(response => response.json())
        //     .then(data => {
        //     });
    }

    onStopScreenShare = () => {
        if (!this.state.isScreenShared) {
            return;
        }
        const { isCustomer } = this.props;
        const { roomId } = this.props.match.params;
        let params = {
            roomId,
            stop: true,
            isCustomer: !!isCustomer
        }
        this.props.updateScreenShareAction(params)
        this.setState({ screenRoomId: '', isScreenShared: false });
    }

    removePicture = () => {
        let captureContainer = document.getElementById('capture-img')
        let captureImage = document.getElementById("photo")
        captureContainer.removeChild(captureImage)
    }
    onCaptureButtonClose = () => {
        this.setState({ isCaptureButton: false }, () => {
            this.removePicture()
        })
    }
    repeatPicture = () => {
        this.removePicture()
        this.takePicture()
    }
    handleChat = (e, check) => {
        if (check) {
            e.preventDefault()
        } else {
            this.setState({ isChatOpened: !this.state.isChatOpened, unreadMessageCount: 0 })
            this.getChatList()
            if (this.state.isVrBackgroundIcon) {
                this.setState({ isVrBackgroundIcon: false })
            }
        }
    }
    handleBackground = (e, check) => {
        if (this.state.isVideoMute && this.state.virtualBackgroundSelectId === 0) {
            toast.warning("Please Turn on your Camera")
        } else {
            this.setState({ isVrBackgroundIcon: !this.state.isVrBackgroundIcon }) // virtual background popup open and close
            if (this.state.isChatOpened) {
                this.setState({ isChatOpened: false }) // if chat popup is opend that time open the virtual background means only colse the chat popup
            }
        }
    }
    handleAvatatOnMute = () => {
        const { isVirtualBackground } = this.state;
        const { isCustomer } = this.props;
        document.querySelectorAll('.inner-media-box').forEach((el) => {
            if (el.parentElement) {
                el.parentElement.removeChild(el);
            }
        });
        const localVideo = document.getElementById('canvasVideo');
        if (localVideo) {
            localVideo.style.visibility = 'hidden';
        }
        if (isVirtualBackground && !isCustomer) {
            const frontVideo = document.getElementById('frCanvas');
            if (frontVideo) {
                frontVideo.style.display = 'none';
            }
        }
    }
    handleAvatatOnUnMute = () => {
        const { isVirtualBackground } = this.state;
        const { isCustomer } = this.props;
        document.querySelectorAll('.inner-media-box').forEach((el) => {
            if (el.parentElement) {
                el.parentElement.removeChild(el);
            }
        });
        const localVideo = document.getElementById('canvasVideo');
        if (localVideo) {
            localVideo.style.visibility = '';
            localVideo.style.display = 'block';
        }
        if (isVirtualBackground && !isCustomer) {
            const frontVideo = document.getElementById('frCanvas');
            if (frontVideo) {
                frontVideo.style.display = 'block';
            }
        } else if (!isCustomer) {
            const frontVideo = document.getElementById('frCanvas');
            if (frontVideo) {
                frontVideo.style.display = 'none';
            }
        }
    }
    ageVerification = () => {
        const { roomId } = this.props.match.params;
        const { verificationImage } = this.state
        this.setState({ isLoading: true })
        let img = verificationImage.substring(verificationImage.indexOf(",") + 1);
        let params = {
            roomId: roomId,
            imageUrl: img
        }
        this.props.ageVerification(params, (res) => {
            this.setState({ isLoading: false })
            if (res?.response?.data?.response_code === 2) {
                toast.error("OCR Server down")
            }
        })
    }
    setIntervalForAutoChangeBackground = (index, virtualBackgroundImages) => {
        if (virtualBackgroundImages.length > 0) {
            backgroundInterval = setInterval(() => {
                if ((virtualBackgroundImages.length - 1) === index) {
                    index = 0;
                } else {
                    index += 1;
                }
                let img = virtualBackgroundImages[index]
                let findDinamicImgDiv = document.getElementsByClassName("dinamicImgDivRender")
                if (findDinamicImgDiv.length > 0) {
                    document.querySelector('#videos-container').removeChild(findDinamicImgDiv[0])
                }
                let createDinamicImg = document.createElement('div');
                createDinamicImg.className = "dinamicImgDivRender"
                createDinamicImg.innerHTML = `<img id='vbackground_${img?.id}' src=${this.setImg(img?.id, img?.imageURL)} alt="dinamic" />`
                document.querySelector('#videos-container').appendChild(createDinamicImg)
                let imgTag = document.getElementById(`vbackground_${img?.id}`)
                imgTag.setAttribute("style", 'display: none')
                if (this.state.virtualBackgroundSelectId && !this.state.isVideoMute) {
                    this.setVideo(imgTag, img.id, false)
                }
            }, 15000);  // 15 sec once virtual background auto change.
        }
    }
    autoChangeBackground = (e, imageIndex, index, virtualBackgroundImages) => {
        clearInterval(backgroundInterval)
        const { isCustomer } = this.props;
        if (this.state.isVideoMute && !isCustomer) {
            return toast.warning("Please Turn on your Camera")
        }
        if (imageIndex != 0) {
            if (this.state.vbOption === 2) {
                this.setIntervalForAutoChangeBackground(index, virtualBackgroundImages)
            }
        }
        this.setVideo(e, imageIndex, true)
    }

    setVideo = (e, imageIndex, loading) => {
        const { isCustomer } = this.props;
        if (this.state.isVideoMute && !isCustomer) {
            return toast.warning("Please Turn on your Camera")
        }
        this.setState({ virtualBackgroundSelectId: imageIndex })
        if (loading) {
            this.setState({ isLoading: true, })
        }
        if (imageIndex == 0) {
            clearInterval(backgroundInterval)
            if (this.state.isVirtualBackground) {
                this.setState({ isVirtualBackground: false, isVirtualBackgroundIMG: e })
                let frontVideo = document.getElementById("canvasVideo")
                if (!isCustomer) {
                    let fronendCanvas = document.getElementById("frCanvas")
                    frontVideo.setAttribute("style", "display: block")
                    fronendCanvas.setAttribute("style", "display:none")
                    this.virtualBackgroundSet(frontVideo, false)
                } else {
                    let backVideo = document.getElementById("video")
                    let backgroundCanvas = document.getElementById("bgCanvas")
                    backVideo.setAttribute("style", "display:block");
                    backgroundCanvas.setAttribute("style", "display:none")
                    this.setState({ isLoading: false })
                    this.virtualBackgroundSet(backVideo, false)
                }
                if (!isCustomer) {
                    const { roomId } = this.props.match.params;
                    let params = {
                        roomId: roomId,
                        id: imageIndex
                    }
                    this.props.vbImage(params, (res) => {
                        this.setState({ isLoading: false })
                        if (res?.response?.data?.response_code === 2) {
                            toast.error(res?.response?.data?.response_message)
                        }
                    })
                }
            } else {
                this.setState({ isLoading: false })
            }
        } else {
            this.setState({ isVirtualBackground: true, isVirtualBackgroundIMG: e })
            const { isCustomer } = this.props;
            let frontVideo = document.getElementById("canvasVideo")
            if (isCustomer) {
                let backVideo = document.getElementById("video")
                let backgroundCanvas = document.getElementById("bgCanvas")
                if (this.state.isScreenView) {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;height: 150px !important;width: auto !important;top: 3vh;right: 2vw;border: 2px solid white;border-radius: 10px;")
                } else {
                    backgroundCanvas.setAttribute("style", "display: block;position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto")
                }
                backVideo.setAttribute("style", "display: none")
                this.canvasRef.current = backgroundCanvas
                this.virtualBackgroundSet(backVideo, true)
                this.setState({ isLoading: false })
            }
            else {
                let fronendCanvas = document.getElementById("frCanvas")
                fronendCanvas.setAttribute("style", "display:block")
                frontVideo.setAttribute("style", "visibility: hidden;position: absolute;")
                this.canvasRef.current = fronendCanvas
                this.virtualBackgroundSet(frontVideo, true)
            }
            if (!isCustomer) {
                const { roomId } = this.props.match.params;
                let params = {
                    roomId: roomId,
                    id: imageIndex
                }
                this.props.vbImage(params, (res) => {
                    this.setState({ isLoading: false })
                    if (res?.response?.data?.response_code === 2) {
                        toast.error(res?.response?.data?.response_message)
                    }
                })
            }
        }

    }
    zoomIn = () => {
        const { isCustomer } = this.props;
        this.setState({ isZoom: true }, () => this.refreshMainVideoAfterZoom());
        if (this.state.isVirtualBackground && isCustomer) {
            let backgroundCanvas = document.getElementById("bgCanvas")
            if (backgroundCanvas) {
                backgroundCanvas.style.objectFit = 'cover';
                this.canvasRef.current = backgroundCanvas
            }
        }
    }
    zoomOut = () => {
        const { isCustomer } = this.props;
        this.setState({ isZoom: false }, () => this.refreshMainVideoAfterZoom());
        if (this.state.isVirtualBackground && isCustomer) {
            let backgroundCanvas = document.getElementById("bgCanvas")
            if (backgroundCanvas) {
                backgroundCanvas.style.objectFit = 'cover';
                this.canvasRef.current = backgroundCanvas
            }
        }
    }

    /** After zoom layout change, force main video to keep painting (avoids black screen). */
    refreshMainVideoAfterZoom = () => {
        const container = document.getElementById('videos-container');
        if (!container) {
            return;
        }
        const isSwapped = container.classList.contains('video-swapped');
        const mainSel = isSwapped
            ? '.media-container.front-video video, .media-container.front-video #frCanvas'
            : '.media-container.background-video video, .media-container.background-video #bgCanvas';
        container.querySelectorAll(mainSel).forEach((el) => {
            try {
                el.style.objectFit = 'cover';
                el.style.objectPosition = 'center center';
                el.style.width = '100%';
                el.style.height = '100%';
                el.style.visibility = 'visible';
                el.style.opacity = '1';
                el.style.display = 'block';
                if (el.tagName === 'VIDEO') {
                    if (el.paused) {
                        this.playStreamSafely(el);
                    }
                    const src = el.srcObject;
                    if (src) {
                        el.srcObject = src;
                        this.playStreamSafely(el);
                    }
                }
            } catch (e) {
                /* ignore */
            }
        });
    }
    changeVbOption = (e) => {
        if (e.target.value == 1) {
            this.setState({ vbOption: 2 })
            if (this.state.isVirtualBackground) {
                this.setIntervalForAutoChangeBackground(0, this.state.virtualBackgroundImages)
            }
        } else {
            this.setState({ vbOption: 1 })
            clearInterval(backgroundInterval)
        }
    }
    render() {
        const { isCustomer, attenedName } = this.props;
        const { isChatOpened, message, customerName, agentName, isMute, avatarmain, isVideoMute, unreadMessageCount = 0, isZoom, isScreenShared, isCaptureButton, isScreenView, screenRoomId, checkIsConnected, isLoading, isMobileDevice, isVrBackgroundIcon, virtualBackgroundSelectId, isVirtualBackground, virtualBackgroundImages, vbOption, language, isSwitchingCamera, localStreamStarted, canSwitchCamera, showCallDuration, callDurationDisplay, showEndCallConfirm, isVideoSwapped } = this.state;
        const chatList = this.props.getChatListAction;
        // const { isLoading } = this.props.customerDeclineLoader;
        // const { appointmentLoading } = this.props.updateAppointmentLoader;
        const { cartGeneration } = attenedName
        let MESSAGE = language === 2 ? stringTamil?.MESSAGE : stringEnglish?.MESSAGE
        return (
            <div className="customer-care-call" id="chat-page">
                {showEndCallConfirm && (
                    <div className="nurse-popup-overlay" role="dialog" aria-modal="true">
                        <div className="nurse-popup-card">
                            <h3 className="nurse-popup-title">{MESSAGE?.WARNING || 'Warning'}</h3>
                            <p className="nurse-popup-desc">{MESSAGE?.END_CALL_MSG || 'Are you sure you want to end the call?'}</p>
                            <div className="nurse-popup-actions">
                                <button type="button" className="nurse-btn nurse-btn-secondary" onClick={() => this.setState({ showEndCallConfirm: false })}>
                                    {MESSAGE?.CANCEL || 'Cancel'}
                                </button>
                                <button type="button" className="nurse-btn nurse-btn-danger" onClick={() => this.confirmEndCall()}>
                                    {MESSAGE?.YES || 'Yes'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {(isLoading) && <AppLoader />}
                <div className="customer-care-call-content">
                    <div className="row bc-black">
                        <div className={`col-12 ${(isChatOpened || isVrBackgroundIcon) ? 'chat-open col-lg-9' : 'col-md-12'} p-0`} id="video-hide">
                            <div
                                id="videos-container"
                                className={`${!isZoom ? 'max-video' : ''} ${isScreenView ? 'video-screen' : ''} ${isScreenShared ? 'is-screen-sharing' : ''} ${isVideoSwapped ? 'video-swapped' : ''} ${avatarmain ? 'remote-cam-off' : ''} ${isVideoMute ? 'local-cam-off' : ''}`.trim()}
                            >
                                {isScreenShared && (
                                    <div className="screen-sharing-badge" aria-live="polite">
                                        You are sharing your screen
                                    </div>
                                )}
                                {showCallDuration && (
                                    <div className="call-duration-badge" aria-live="polite">
                                        {callDurationDisplay}
                                    </div>
                                )}
                                {/* Original left-corner Zoom In / Out — full size vs fit-to-device */}
                                {!isScreenView && (
                                    <>
                                        {!isZoom && (
                                            <div className="zoom-icon zoomInTooltip" title="Zoom In" onClick={() => this.zoomIn()}>
                                                <i className="fas fa-expand-arrows-alt"></i>
                                            </div>
                                        )}
                                        {isZoom && (
                                            <div className="zoom-icon zoomOutTooltip" title="Zoom Out" onClick={() => this.zoomOut()}>
                                                <i className="fas fa-compress-arrows-alt"></i>
                                            </div>
                                        )}
                                    </>
                                )}
                                {(avatarmain && !isScreenView) && (
                                    <div
                                        className={`camera-off-tile camera-off-remote ${isVideoSwapped ? 'is-pip' : 'is-main'}`}
                                        onClick={isVideoSwapped ? (e) => { e.stopPropagation(); this.toggleVideoSwap(); } : undefined}
                                        role={isVideoSwapped ? 'button' : undefined}
                                        title={isVideoSwapped ? 'Tap to swap' : undefined}
                                    >
                                        <div className="camera-off-icon" aria-hidden="true">
                                            <i className="fa-solid fa-video-slash"></i>
                                        </div>
                                        <div className="camera-off-avatar" aria-hidden="true">
                                            {this.getNameInitial(isCustomer ? (agentName || 'Nurse') : customerName, isCustomer ? 'N' : 'C')}
                                        </div>
                                        <p className="camera-off-label">Camera is off</p>
                                    </div>
                                )}
                                {(isVideoMute && !isScreenView) && (
                                    <div
                                        className={`camera-off-tile camera-off-local ${isVideoSwapped ? 'is-main' : 'is-pip'}`}
                                        onClick={!isVideoSwapped ? (e) => { e.stopPropagation(); this.toggleVideoSwap(); } : undefined}
                                        role={!isVideoSwapped ? 'button' : undefined}
                                        title={!isVideoSwapped ? 'Tap to swap' : undefined}
                                    >
                                        <div className="camera-off-icon" aria-hidden="true">
                                            <i className="fa-solid fa-video-slash"></i>
                                        </div>
                                        <div className="camera-off-avatar" aria-hidden="true">
                                            {this.getNameInitial(isCustomer ? (customerName || 'You') : (agentName || 'Nurse'), isCustomer ? 'Y' : 'N')}
                                        </div>
                                        <p className="camera-off-label">Camera is off</p>
                                    </div>
                                )}
                                <div className="d-flex justify-content-center  customer-end-call-content icons">
                                    {isMute ? (<div className="cuatomer-call-circle-slash mx-3 OnMuteIcon unMuteMicTooltip" title={MESSAGE?.MIC?.UNMUTE} onClick={() => this.onUnMute()}>
                                        <i className="fa-solid fa-microphone-slash mic-icon-slash"></i>
                                    </div>) :
                                        (<div className="cuatomer-call-circle mx-3 OnMuteIcon" title={MESSAGE?.MIC?.MUTE} onClick={(e) => this.onMute(e, checkIsConnected)}>
                                            <i className="fa-solid fa-microphone mic-icon muteMicTooltip" ></i>
                                        </div>)}
                                    {isVideoMute ? (<div className="cuatomer-call-circle-slash mx-3 OnVideoMute unMuteVideoTooltip" title={MESSAGE?.VIDEO?.UNMUTE} onClick={() => this.onUnMuteVideo()}>
                                        <i className="fa-solid fa-video-slash mic-icon-slash" ></i>
                                    </div>) :
                                        (<div className="cuatomer-call-circle mx-3 OnVideoMute muteVideoTooltip" title={MESSAGE?.VIDEO?.MUTE} onClick={(e) => this.onMuteVideo(e, checkIsConnected)}>
                                            <i className="fa-solid fa-video-camera mic-icon"></i>
                                        </div>)}
                                    {localStreamStarted && canSwitchCamera && (
                                        <div
                                            className={`cuatomer-call-circle mx-3 kioskSwitchCameraTooltip${isSwitchingCamera ? ' pe-none opacity-50' : ''}`}
                                            title={MESSAGE?.CAMERA?.SWITCH}
                                            onClick={() => !isSwitchingCamera && this.switchCamera()}
                                        >
                                            <i className="fa-solid fa-camera-rotate mic-icon"></i>
                                            <Tooltip anchorSelect=".kioskSwitchCameraTooltip" place="top">
                                                {MESSAGE?.CAMERA?.SWITCH}
                                            </Tooltip>
                                        </div>
                                    )}
                                    <div className="cuatomer-call-circle mx-3 OnEndCall endCallTooltip" title={MESSAGE?.END_CALL} onClick={() => this.setState({ showEndCallConfirm: true })}>
                                        <i className="fa-solid fa-phone call-icon"></i>
                                    </div>
                                    {/* Removed other then audio, video and end */}
                                    {/* <div className="cuatomer-call-circle mx-3 p-relative OnHandleIcon chatTooltip" id="chat-icon" onClick={(e) => this.handleChat(e, checkIsConnected)}>
                                        {unreadMessageCount > 0 && <div className="chat-count">{unreadMessageCount}</div>}
                                        <i className='fa-solid fa-comment-dots chat-icon1'></i>
                                        <Tooltip anchorSelect=".chatTooltip" place="top">
                                            Chat
                                        </Tooltip>
                                    </div>
                                    {(!isCustomer && virtualBackgroundImages?.length > 0) && <div className={`mx-3 p-relative OnHandleIcon virtualBackgroundTooltip ${isVirtualBackground ? "cuatomer-call-circle-slash" : "cuatomer-call-circle"} `} id="chat-icon" onClick={(e) => this.handleBackground(e, checkIsConnected)}>
                                        <i className={`fa-solid fa-chalkboard chat-icon1 ${isVirtualBackground ? "onScreenShareIcon" : ""}`}></i>
                                        <Tooltip anchorSelect=".virtualBackgroundTooltip" place="top">
                                            Virtual Background
                                        </Tooltip>
                                    </div>}
                                    {cartGeneration == 1 &&
                                        <>
                                            {!isCustomer && <div className="cuatomer-call-circle mx-3 OnOpenApp shopptingTooltip" id="chat-icon">
                                                <i className="fa fa-cart-plus  mic-icon" onClick={() => this.openApp()}></i>
                                                <Tooltip anchorSelect=".shopptingTooltip" place="top">
                                                    Shopping
                                                </Tooltip>
                                            </div>}
                                            {(!isCustomer && !isMobileDevice) &&
                                                <div className={`${!isScreenShared ? 'cuatomer-call-circle screenShareTooltip' : 'cuatomer-call-circle-slash'} mx-3 OnScreenStart`} id="chat-icon" onClick={() => isScreenShared ? this.onStopScreenShare() : this.onStartScreenShare()}>
                                                    <i className={`${isScreenShared && 'onScreenShareIcon'} fa-solid fa-arrow-up-from-bracket chat-icon1`}></i>
                                                    <Tooltip anchorSelect=".screenShareTooltip" place="top">
                                                        {
                                                            isScreenShared ? "Stop Screen Share" : "  Screen Share"
                                                        }
                                                    </Tooltip>
                                                </div>}
                                            {(!isCustomer) &&
                                                <div className="capture_icon">
                                                    <div className={`${!isCaptureButton ? 'cuatomer-call-circle ' : 'cuatomer-call-circle-slash '} mx-3 OnScreenStart`} id="chat-icon"
                                                        onClick={() => isCaptureButton ? this.onCaptureButtonClose() : this.onCaptureButtonOpen()}>
                                                        {!isCaptureButton ?
                                                            <>
                                                                <i className={`fa-solid fa-camera chat-icon1 captureTooltip`}></i>
                                                                <Tooltip anchorSelect=".captureTooltip" place="top">
                                                                    Capture
                                                                </Tooltip>
                                                            </>
                                                            :
                                                            <>
                                                                <i className={`${isCaptureButton && 'onScreenShareIcon captureCloseTooltip'} fa-solid fa-x chat-icon1`}></i>
                                                                <Tooltip anchorSelect=".captureCloseTooltip" place="top">
                                                                    Close
                                                                </Tooltip>
                                                            </>
                                                        }
                                                    </div>

                                                    {isCaptureButton &&
                                                        <div className="capture_open_icon">
                                                            <div className={`cuatomer-call-circle mx-3 OnScreenStart retakeTooltip`} id="chat-icon" onClick={() => this.repeatPicture()}>
                                                                <i className={`fa-solid fa-repeat chat-icon1`}></i>
                                                                <Tooltip anchorSelect=".retakeTooltip" place="top">
                                                                    Retake
                                                                </Tooltip>
                                                            </div>
                                                            <div className={`cuatomer-call-circle mx-3 OnScreenStart submitTooltip`} id="chat-icon" onClick={() => this.ageVerification()}>
                                                                <i className={`fa-solid fa-check chat-icon1`}></i>
                                                                <Tooltip anchorSelect=".submitTooltip" place="top">
                                                                    Submit
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </>
                                    } */}
                                </div>
                                {(isScreenShared || isScreenView) && <ScreenShare share={isScreenShared} view={isScreenView} roomId={screenRoomId} onScreenShared={(d) => this.onScreenShared(d)} onStopScreenShare={this.onStopScreenShare} />}
                            </div>
                            <div className="mx-3">
                                {(!isCustomer) &&
                                    <>
                                        <canvas id="canvas"> </canvas>
                                        <div className="scan-box" id="capture-img"></div>
                                    </>}
                            </div>
                        </div>
                        {isChatOpened && <div className="col-12 col-lg-3 p-0" style={{ borderRadius: 0, zIndex: 111 }}>
                            <div className="card chat-card" id="chart-page">
                                <div className="card-header heading-part">
                                    <div className="d-flex head-content">
                                        <div className="chat-left">
                                            <i className="fa-solid fa-comment-dots chat-icon"></i>
                                            <p className="chat-text">{Constants.CHAT}</p>
                                        </div>
                                        <i className="fa-solid fa-close close-icon" id="close-query" onClick={() => this.setState({ isChatOpened: false })}></i>
                                    </div>
                                </div>
                                <div className="card-body chat-body-content">
                                    {Array.isArray(chatList) && chatList?.map((message, i) => {
                                        return (<div className="message-content" key={i}>
                                            <div className={`message-content-box 
                                             ${this.props.isCustomer ?
                                                    message.messageType === 4 ? 'me' : ''
                                                    : message.messageType === 3 ? 'me' : ''
                                                }`}>
                                                <div className="message-text">
                                                    {(message?.message?.includes(`https://${SHOPPING_DOMAIN}/customercare/payment`) ||
                                                        message?.message?.includes("paulsfashion.myshopify")) ? <div>
                                                        <QRCode
                                                            value={message.message}
                                                        /><br />
                                                        {isCustomer && <span style={{ color: '#0d6efd', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => this.openLink(message.message)}>{Constants.PAY_NOW}</span>}
                                                    </div> : message.message}
                                                </div>
                                            </div>
                                        </div>)
                                    })}
                                </div>
                                <div className="card-footer chat-footer">
                                    <div className="input-content">
                                        <input autoComplete="off" type="text" className="form-control type-message" placeholder="Type a message"
                                            value={message} name="message" onChange={(e) => this.handleChange(e)} onKeyUp={(e) => this.handleKeyUp(e)} />
                                    </div>
                                    <i className="fas fa-paper-plane send-icon" onClick={() => this.sendMessage()}></i>
                                </div>
                            </div>
                        </div>}
                        {isVrBackgroundIcon && <div className="col-12 col-lg-3 p-0" style={{ borderRadius: 0, zIndex: 111 }}>
                            <div className="card chat-card" id="chart-page">
                                <div className="card-header heading-part">
                                    <div className="d-flex head-content">
                                        <div className="chat-left">
                                            <i className="fa-solid fa-chalkboard chat-icon"></i>
                                            <p className="chat-text">Virtual Background</p>
                                        </div>
                                        <i className="fa-solid fa-close close-icon" id="close-query" onClick={() => this.setState({ isVrBackgroundIcon: false })}></i>
                                    </div>
                                </div>
                                <div className="card-body chat-body-content">
                                    <p className="m-0">No effects</p>
                                    <div className="row m-0">
                                        <div className="col-6 px-2 py-2">
                                            <div className={`noeffect_box ${virtualBackgroundSelectId === 0 ? " bg_active" : ""}`}>
                                                <img id="vbackground_0" src={NoEffect} alt="No effect" width="30%" onClick={(e) => this.setVideo(e.target, 0, true)} />
                                            </div>
                                        </div>
                                    </div>
                                    <p className="mb-0 mt-1">{virtualBackgroundImages.length > 1 ? "Backgrounds" : "Background"}</p>
                                    {virtualBackgroundImages.length > 1 && <div className="row m-0 mt-3">
                                        <div onClick={(e) => { this.changeVbOption(e) }}>
                                            View Options &nbsp; &nbsp;
                                            <input type="radio" value={vbOption} name="vbOption" checked={vbOption === 1 ? true : false} /> Static &nbsp;
                                            <input type="radio" value={vbOption} name="vbOption" checked={vbOption === 2 ? true : false} /> Loop &nbsp;
                                        </div>
                                    </div>}
                                    <div className="row m-0">
                                        {virtualBackgroundImages?.map((img, i) => {
                                            return <div className="col-6 px-2 py-2" key={i}>
                                                <div className={`bg_effect_align ${virtualBackgroundSelectId === img?.id ? " bg_active" : ""}`}>
                                                    <img id={`vbackground_${img?.id}`} src={img?.imageURL} alt="The Screen" onClick={(e) => this.autoChangeBackground(e.target, img?.id, i, virtualBackgroundImages)} />
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }
}
export const mapStateToProps = (state) => {
    return {
        getTokenDetails: state,
        getCustomerToken: state?.CUSTOMER_LIST?.customerList?.response?.User,
        getChatListAction: state?.CHAT_LIST?.currentArrayList,
        getQueueList: state?.CHAT_LIST,
        isCallAttended: state?.FEEDBACK?.isAttended,
        attenedName: Actions.getLoginDetails(state),
        callerName: Actions.getCustomerCallListDetails(state),
        appointmentDetails: state?.UPDATE_APPOINTMENT?.updateAppointment?.response,
        customerDeclineLoader: state?.CUSTOMER_DECLINE,
        chatListLoader: state?.CHAT_LIST,
        updateAppointmentLoader: state?.UPDATE_APPOINTMENT
    }
};
export default withRouter(connect(mapStateToProps, {
    customerDeclineAction: Actions.customerDeclineAction,
    updateAppointment: Actions.updateAppointmentAction,
    chatListAction: Actions.chatListAction,
    virtualBackgroundListAction: Actions.getAgentVbImageList,
    addChatListAction: Actions.addChatListAction,
    appendChat: Actions.appendChatAction,
    socketAppendChatAction: Actions.socketAppendChatAction,
    appendQueueList: Actions.addChatQueueList,
    screenShareAction: Actions.screenShareAction,
    updateScreenShareAction: Actions.updateScreenShareAction,
    ageVerification: Actions.getAgeVerificationAction,
    vbImage: Actions.getVirtualBackgroundAction
})(KioskVerification))